import React from 'react'
import ProfileChangePhone from './ProfileChangePhone';
import successIcon from 'assets/img/icons/success-green-big.svg'
import failIcon from 'assets/img/icons/icon-warning.svg'
import ProfileChangePassword from './ProfileChangePassword';
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton';
import ProfileChangeEmail from './ProfileChangeEmail';
import ProfileChangeRealName from './ProfileChangeRealName';
import ModalWindow from 'components/ModalWindow';

const ProfileChangePopup = ({ type, close, onUpdateEmail, onUpdateRealName, onUpdatePhoneNumber, onUpdatePassword }) => {
  return (
    <ModalWindow close={close} >
      <div className='modal-window__wrapper' onClick={(e) => e.stopPropagation()}>
        <PagePopopCloseButton close={close} />
        {type === 'email' && <ProfileChangeEmail successIcon={successIcon} failIcon={failIcon} close={close} onUpdateEmail={onUpdateEmail} />}
        {type === 'real-name' && <ProfileChangeRealName successIcon={successIcon} failIcon={failIcon} close={close} onUpdateRealName={onUpdateRealName} /> }
        {type === 'phone' && <ProfileChangePhone successIcon={successIcon} failIcon={failIcon} close={close} onUpdatePhoneNumber={onUpdatePhoneNumber} />}
        {type === 'password' && <ProfileChangePassword successIcon={successIcon} failIcon={failIcon} close={close} onUpdatePassword={onUpdatePassword} />}
      </div>
    </ModalWindow>
  )
}

export default ProfileChangePopup;
